import { FC } from 'react'
import { getBaseExplorerUrl } from '@/utils/blockchain'
import { formatHash } from '@/utils/format'
import { CopyableContent } from './CopyableContent'
import { ExplorerTransactionType } from '@/types/transaction'
import { Button } from './ui/button'

type AddressFormat = 'short' | 'long'

interface Props {
  address?: string
  format?: AddressFormat
  length?: number
  type?: ExplorerTransactionType
}

export const Address: FC<Props> = ({
  address,
  format = 'short',
  length = 6,
  type = ExplorerTransactionType.ADDRESS,
}) => {
  if (!address) {
    return '-'
  }

  const formattedAddress = format === 'short' ? formatHash(address, length) : address

  return (
    <div className="flex items-center gap-2">
      <CopyableContent content={address}>
        <Button variant="link" className="p-0 h-3" asChild>
          <a title={address} href={getBaseExplorerUrl(address, type)} target="_blank" rel="noopener noreferrer">
            {formattedAddress}
          </a>
        </Button>
      </CopyableContent>
    </div>
  )
}
